import { render, staticRenderFns } from "./ProcessedOrders.vue?vue&type=template&id=405f1449&"
import script from "./ProcessedOrders.vue?vue&type=script&lang=js&"
export * from "./ProcessedOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports